module.exports = __webpack_public_path__ + "img/gestion_archives.471ef809.png";